<template>
  <label
    class="text"
    :class="rootClasses"
  >
    <span class="text__label">{{ title }}</span>
    <input
      class="text__input"
      data-lpignore="true"
      type="text"
      :inputmode="inputMode"
      :aria-invalid="hasViolations"
      :aria-label="ariaLabel"
      :maxlength="maxlength"
      :name="name"
      :pattern="pattern"
      :placeholder="placeholder"
      :required="required"
      :readonly="readonly"
      :value="modelValue"
      :disabled="disabled"
      @input="onInput"
    >
    <p
      v-for="violationText in violations"
      :key="violationText"
      class="text__violation"
      role="alert"
    >{{ violationText }}</p>
  </label>
</template>
<script>

/**
 * @description Название события ввода.
 * @type {string}
 */
const NAME_EVENT_UPDATE_MODEL_VALUE = 'update:model-value';

/**
 * @description Компонент ввода однострочного текста.
 * @type {Vue}
 */
export default {
  name: 'InputText',
  props: {
    /**
     * @description Описание элемента.
     */
    ariaLabel: { default: () => undefined, type: [String, Boolean] },
    /**
     * @description Максимальная длина.
     */
    maxlength: { default: () => undefined, type: [String, Number, Boolean] },
    /**
     * @description Регулярное выражение для проверки данных в поле.
     */
    pattern: { default: () => undefined, type: [String, Boolean] },
    /**
     * @description Уникальное имя элемента формы.
     */
    name: { default: () => undefined, type: [String, Boolean] },
    /**
     * @description Тип раскладки виртуальной клавиатуры.
     */
    inputMode: { default: () => 'text', type: String },
    /**
     * @description Поле обязательно для заполнения.
     */
    required: { default: () => false, type: [String, Boolean] },
    /**
     * @description Поле обязательно для чтения.
     */
    readonly: { default: () => false, type: Boolean },
    /**
     * @description Текст заполнитель.
     */
    placeholder: { default: () => undefined, type: [String, Boolean] },
    /**
     * @description Заголовок.
     */
    title: { default: () => '', type: String },
    /**
     * @description Значение.
     */
    modelValue: { required: true, type: String },
    /**
     * @description Деактивирован
     */
    disabled: { default: () => false, type: Boolean },
    /**
     * @description Список нарушений.
     */
    violations: { default: () => [], type: Array },
  },
  emits: [NAME_EVENT_UPDATE_MODEL_VALUE],
  computed: {
    /**
     * @description Имеет нарушения.
     * @type {boolean}
     */
    hasViolations() {
      return this.violations.length > 0;
    },
    /**
     * @description Список классов корневого элемента.
     * @type {string[]}
     */
    rootClasses() {
      const list = [];
      if (this.hasViolations) {
        list.push('invalid');
      }
      return list;
    },
  },
  methods: {
    /**
     * @description Обработать ввод.
     * @param {InputEvent} event Событие.
     * @returns {void}
     */
    onInput(event) {
      this.$emit(NAME_EVENT_UPDATE_MODEL_VALUE, event.target.value);
    },
  },
};
</script>
